// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + (chunkId === "850" ? "monaco-editor" : chunkId) + "." + {"227": "281c7fe8","425": "9ae8ba05","445": "c3808f46","51": "42a35068","850": "e56fa031",}[chunkId] + ".css"
}